import Vue from "vue";

export function saveIpAutoLoginToken(token) {
  if (!token) {
    return false;
  }
  Vue.ls.set("ACCESS_TOKEN", token);
  return true;
}
